import env from "./env";

export const totalExternalItSpendCategory = "2BF77184F55403D75B9D51D79162A7CA";
export const OTHER_DEPARTMENT_ID = 11;
export const softwareProductCategory = [
  "319D067B229178F03BCFA1DA4AC4DEDE",
  "3F91B0FD060DFF4F4BD2521FF03649D7",
  "30F42FE1419E07B89C8B2E055848126C",
  "2ED60A65067A202A9884B728B010D283",
  "AEDCF18415E6469B53C2E9DE61C84AA",
  "35F825D670538FEB28497F2FE72D9864",
  "2AEB5D04A48C2D267BA421A04C29DD77",
  "1EC5928D0594F72573FC0E791CEDB2C7",
  "13B32AC768996CC7639B39455775029B",
  "27DBE38747BDA653648C332178C2AD44",
  "20DF9B5A841FC98FF1597AABF59A700F",
  "3148530A5AA711D79FDB4DE7E0AC72BC",
  "18DFA3826480C80DF8607387FF67EE7F",
  "1112BD959AED2E94AE218F996865A7A1",
  "1C96B1917FAFA4F0949E5F6C1D336E77",
  "107930B8DEEF58FB02DFC0883748EA84",
  "2A711A1375909CEC45E436DEF9B9FFA9",
  "1023913E9AEC9ED741E2763866101657",
  "EABC5534A622DCAE43DBC469EDDEBD9",
  "1D37FA587E73771707110FD56684D949",
  "21DDB505FB52761D42BA2526D04DDE64",
  "63E88D6A88D45AB23B4CB4E71CB5A2E",
  "450D8C9CB5523C08C3684C31BF161C4",
  "A3D4DDFF38FABC23B56D817EA62EFDF",
  "1557F8988E1FC1410A39A4EA09FB6B1C",
  "106F065A008A8A61873F7CAA347E2A84",
  "30F25DBD6A21A13B9B809FBBC8780EED",
  "3725081403444B68508CB0CF6293961A",
  "155C4C3433C0F67638351D1EAE957B6C",
  "9FEA1A8D740555141461A3AD2BEDD39",
  "3A40873484DAECD2ED685BA24CB1DD1A",
  "1C59295B574D410D8E7C3D37A28A017E",
  "3D4E50A8D6285DC9DA50D8C66737C400",
  "382C997E1CA2582F938FB1B8558F36A2",
  "17AB03692959A4E1A4E6A11A2C3ACD53",
  "35BFFDE5D3E273DBD3105A509C6C72B0",
  "374546C4A59DC3F44C6EB3608751EDC7",
  "106AD4393A30768E93B8C6121936C0E",
  "148EC4B995226416EBC8BE44C24D65E8",
  "1538B167EF072854DD398B0A92E4E48A",
  "1B45A740FC4C3958BDF5957F142D6A7E",
  "E24E3ADD202D47F63F68C5BFA6E76AF",
  "37662F074873CFA772BABB2BFF9249B2",
  "296F4C1921B080483BF4D1073480B5B3",
  "3E2E2C39D10C534DF1D8E9637084EAF3",
  "975FC8A751BA997F273A01B5C2E7C55",
  "1116D31755E1D8A52DD1B39108101572",
  "121A878485B7D321FE25B7762DAEF3AF",
  "38093F98544C2E2F56C2662DE78201A3",
  "FC7A1899228E315AA8E33C553540A7B",
  "36B66338C0608A067862FDFB56580A02",
  "4497DF660967DF92548BB1C668AC4AE",
  "37C39E78F1AA7F01357421311AA4DB7B",
  "28884CC6A848078A69CDA53CF40E17C5",
  "1418B319B0BF64082F35286B055DDCC1",
  "42F74E52E5D3526C74C58A396484782",
  "3F29441140F200C0D6A3AD354A55FDF",
  "2657A0820463D8D5B8219F9BC061524E",
  "243848D5AFA60192E663FAAEC275D379",
  "21551A58F03D28BD107911B5D0654B89",
  "E8EC0AF8B6CA5F2C7AB88055573A179",
  "265551D4110B31C3CEBB3774493BC8A5",
  "33DBD5E766A631FC21CEBFB99B576005",
  "D07860B069867D6BFF823266F41A1DE",
  "31F827BF60C5EECD67EEB95AFB029D68",
  "1B18A4439E5EE783C2FE5130E1A323EE",
  "4CFC629A341B83BA6E9E93926707665",
  "3446E79DE8FD6407BD12158DA247B73",
  "FCCBA4A208F2099EAA6837E1DC17A19",
  "29E3994FD32AD9509DD9EDABD54B0FFF",
  "2902A516EC162D1737C3690F72D609D9",
  "32794972AECA81CE9577E386784BBC9E",
  "3F077D3B74649355EEA00A10A50D3C88",
  "26CBC3A58F71A76B2D3D8727E0A43E92",
  "131A1B5C1C4EA6D22D76808553248CBD",
  "1CD0024569FAA786304FE2B594AC0585",
  "30B24B725780AF80BFA807E9C6A498AD",
  "1A2D246D321C3B3CE41FB700B0B042D9",
  "1FAD6571F8325FAEB679FD050D78E7B0",
  "1C8DFE0F2B290F00B53B5FB015F3C9B4",
  "A763C5454885937B5A60ECC3D76F04B",
  "3C6406F43218A76A6A8531D8B7C03B0D",
  "14C1AACD70915CD28087918ECF03BB3C",
  "1AF99671EE34AA524D29A4B0AB2112B9",
  "73C98CA59296B8D1040E58F289A9370",
  "2038BA77E0DA4713675B1C9A03613506",
  "11BDDBF80EBE6EAA2374F0DEEDBE3217",
  "18C706AE03AEAE9B4CE2323F2BFBDD5",
];

export const TAXONOMY_CLIENT = "taxonomy";
export const COMPANY_SEARCH_CLIENT = "companySearch";
export const COMPANY_MATCH_CLIENT = "companyMatch";
// company-search-api through the multipart (Absinthe upload) link, for file uploads
export const COMPANY_SEARCH_UPLOAD_CLIENT = "companySearchUpload";
export const OVERSEER_CLIENT = "overseerApi";
export const HG_FORCE_CLIENT = "hgForce";
export const SCORING_CLIENT = "scoring";

export const PLATFORM_AUTH_URL = new URL(env.PLATFORM_URL_BASE + "/auth");
export const PLATFORM_LOGOUT_URL = new URL(
  env.PLATFORM_URL_BASE + "/auth/logout"
);
export const CLAIMS = "claims";

// mk-auth OAuth 2.0 configuration
export const MK_AUTH_SERVER_URL =
  env.MK_AUTH_SERVER_URL || "http://localhost:5173/api";
export const MK_AUTH_OAUTH_AUTHORIZE_URL = `${MK_AUTH_SERVER_URL}/oauth/authorize`;
export const MK_AUTH_CLIENT_ID = env.MK_AUTH_CLIENT_ID || "";
export const CLAIM_TYPES = {
  dnbDataEnabled: "dnbDataEnabled",
  exportAbility: "exportAbility",
  creditsEnforcementEnabled: "creditsEnforcementEnabled",
  rgifPlatformEnabled: "rgifPlatformEnabled",
  hgForceEnabled: "hgForceEnabled",
};
export const LEGACY_SCOPES = {
  exportAbility: "access:export",
  spendView: "access:spend-view",
  contractView: "access:contract-view",
  installView: "access:install-view",
};
